import React from 'react';
import PatientQueue from './PatientQueue';

// Types 27-30 are the RPM threshold/adherence alerts. They are worked from
// Urgent - RPM Threshold Alerts (APP-3772), so they are excluded here rather than shown twice.
const UrgentQueueCne = () =>
    <PatientQueue
        showQueueCount
        patientDetailColumn
        timeBilledColumn
        providerDetailColumn
        urgentColumn
        todoItemColumn
        showFilters
        showProgramTypeFilter
        showScheduleCallFilter
        statusColumn
        chartColumn
        lastWorkedByColumn
        lastOutCallColumn
        callAttemptsCol
        showSort
        sortOptions={[
            {
                'name': 'Last Called Ascending',
                'key': 'lastOutCallTs&dir=asc',
            },
            {
                'name': 'Last Called Descending',
                'key': 'lastOutCallTs&dir=desc',
            }
        ]}
        page
        queue="urgentCne"
        endpoint="Urgent?typesToExclude=6,16,18,19,27,28,29,30"
        label="Urgent"
    />;

export default UrgentQueueCne;
